import { css } from 'styled-components'

const extendStylesDropdownRating = css`
    /* width: 146px; */
    width: 268px;
`;

export {
    extendStylesDropdownRating
}